import React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const CommonSlider = ({ children, pageTitle }) => {
  // Slider settings
  let settings = {
    dots: pageTitle === "Property Management" ? true : false,
    autoplay: pageTitle === "Property Management" ? true : false,
    autoplaySpeed: 7000,
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          arrows: false,
          dots: pageTitle === "Property Management" ? true : false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <Slider className="common-slider" {...settings}>
        {children}
    </Slider>
  )
}

export default CommonSlider